import React, { useState, useEffect } from 'react';
import { NtIcon } from './NotionUI';

/**
 * Pulsante che apre un piccolo menu di azioni.
 * `items`: [{ label, icon, onClick, danger, on, divider }] — `on` mostra un pallino verde (funzione attiva).
 * `iconOnly`: solo icona (tre puntini) invece dell'etichetta; `align`: lato su cui si allinea il menu.
 */
function ActionMenu({ label, icon, iconOnly = false, ariaLabel, items, align = 'left', triggerClass, block = false, caret = true }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <span className={'am-wrap' + (block ? ' am-block' : '')}>
      <button
        type="button"
        className={triggerClass || (iconOnly ? 'am-icon' : 'am-trigger')}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={ariaLabel || label}
        title={ariaLabel || undefined}
        onClick={() => setOpen((v) => !v)}
      >
        {iconOnly ? <NtIcon name="more" size={18} /> : (
          <>
            {icon && <NtIcon name={icon} size={15} />} {label} {caret && <span className="am-caret" aria-hidden="true">▾</span>}
          </>
        )}
      </button>
      {open && (
        <>
          <div className="am-overlay" onClick={() => setOpen(false)} />
          <div className={`am-menu am-${align}`} role="menu">
            {items.map((item, i) => (item.divider ? <div key={`d${i}`} className="am-divider" /> : (
              <button
                key={item.label}
                type="button"
                role="menuitem"
                className={'am-item' + (item.danger ? ' am-danger' : '')}
                disabled={item.disabled}
                onClick={() => {
                  setOpen(false);
                  item.onClick();
                }}
              >
                {item.icon && <NtIcon name={item.icon} size={15} />}
                {item.prefix && <span aria-hidden="true">{item.prefix}</span>}
                <span className="am-label">{item.label}</span>
                {item.on && <i className="am-on" aria-hidden="true" />}
              </button>
            )))}
          </div>
        </>
      )}
    </span>
  );
}

export default ActionMenu;
